import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';

/**
 * ResponsiveTable - Tabla que se convierte en cards en móvil
 * 
 * @param {Array} data - Array de objetos con los datos
 * @param {Array} columns - Array de objetos con {key, label, render (opcional)}
 * @param {String} emptyMessage - Mensaje cuando no hay datos
 */
export const ResponsiveTable = ({ data, columns, emptyMessage = "No hay datos" }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500">
        {emptyMessage}
      </div>
    );
  }

  return (
    <>
      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map((col) => (
                <TableHead key={col.key || col.label} className={col.className}>
                  {col.label}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((item) => (
              <TableRow key={item.id || item.key || JSON.stringify(item)}>
                {columns.map((col) => (
                  <TableCell key={col.key || col.label} className={col.cellClassName}>
                    {col.render ? col.render(item) : item[col.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden space-y-3">
        {data.map((item) => (
          <div 
            key={item.id || item.key || JSON.stringify(item)} 
            className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-4 shadow-sm"
          >
            {columns.map((col) => (
              <div key={col.key || col.label} className="flex justify-between items-center py-2 border-b border-slate-100 dark:border-slate-700 last:border-b-0">
                <span className="text-sm font-medium text-slate-600 dark:text-slate-400">
                  {col.label}
                </span>
                <span className="text-sm font-semibold text-slate-900 dark:text-white text-right">
                  {col.render ? col.render(item) : item[col.key]}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};
